import { resetPasswordSchema } from "@closer/shared";
import { Button, Card, FormField, Input, useToast } from "@closer/ui";
import { Link, useNavigate, useSearchParams } from "react-router";
import type { z } from "zod";

import { api, ApiRequestError } from "../../lib/apiClient";
import { applyServerErrors, useZodForm } from "../../lib/useZodForm";

type ResetValues = z.infer<typeof resetPasswordSchema>;

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const navigate = useNavigate();
  const toast = useToast();
  // token URL'den gelir, forma gizli varsayılan olarak taşınır (şema token min 1 ister)
  const form = useZodForm(resetPasswordSchema, {
    defaultValues: { token, password: "" } as ResetValues,
  });

  const onSubmit = form.handleSubmit(async (values) => {
    try {
      await api<null>("/api/session/reset-password", {
        method: "POST",
        body: JSON.stringify(values),
      });
      toast.success("Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.");
      navigate("/login");
    } catch (error) {
      applyServerErrors(form, error);
      toast.error(
        error instanceof ApiRequestError
          ? error.message
          : "İşlem tamamlanamadı. Lütfen tekrar deneyin.",
      );
    }
  });

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <Card title="Yeni Şifre Belirle" className="w-full max-w-sm">
        {token ? (
          <form onSubmit={onSubmit} noValidate className="flex flex-col gap-4">
            <FormField label="Yeni Şifre" error={form.formState.errors.password?.message} required>
              <Input type="password" autoComplete="new-password" {...form.register("password")} />
            </FormField>
            <Button type="submit" loading={form.formState.isSubmitting}>
              Şifreyi Güncelle
            </Button>
            <p className="text-center text-sm text-slate-500">
              <Link to="/login" className="font-medium text-primary hover:underline">
                Giriş sayfasına dön
              </Link>
            </p>
          </form>
        ) : (
          <div className="flex flex-col gap-4">
            <p role="alert" className="text-sm text-slate-600">
              Sıfırlama bağlantısı geçersiz veya eksik. Lütfen yeni bir bağlantı isteyin.
            </p>
            <Link
              to="/forgot-password"
              className="text-center font-medium text-primary hover:underline"
            >
              Yeni bağlantı iste
            </Link>
          </div>
        )}
      </Card>
    </div>
  );
}
